// React JSX transform handles React import automatically
import { Layout, Typography } from 'antd';
import { AuthProvider, useAuth } from './stores/AuthContext';
import LoginPage from './modules/auth/LoginPage';
import MainLayout from './components/MainLayout';

const { Content } = Layout;
const { Title } = Typography;

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Layout style={{ minHeight: '100vh', justifyContent: 'center', alignItems: 'center' }}>
        <Content>
          <Title level={3}>Завантаження...</Title>
        </Content>
      </Layout>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <MainLayout />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
